import { Typography } from '@mui/material';

import { ChargingModel } from 'modules/billing/types';
import { ChargingModelLabel } from 'modules/billing/components/ChargingModelLabel';
import { Placeholder } from 'modules/common/components/Placeholder';
import { PromoBadge } from 'modules/common/components/PromoBadge';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { useHeaderStyles } from './useHeaderStyles';
import { headerTranslation } from './translation';

export interface HeaderProps {
  chargingModel: ChargingModel | undefined;
}

export const Header = ({ chargingModel }: HeaderProps) => {
  const { classes } = useHeaderStyles();
  const { keys, t } = useTranslation(headerTranslation);

  const isPromo = chargingModel?.type === 'promo';

  return (
    <div className={classes.root}>
      <Typography variant="subtitle3">{t(keys.title)}</Typography>
      <Placeholder hasPlaceholder={isPromo} placeholder={<PromoBadge />}>
        <ChargingModelLabel
          chargingModel={chargingModel}
          className={classes.label}
          size="small"
        />
      </Placeholder>
    </div>
  );
};
